import { useState } from "react";
import { ExternalLink } from "lucide-react";
import { mediaItems } from "../data/sumoDidiMedia";

export default function SumoDidiMedia({ layout = "stack", showLinks = false, only = null }) {
  const items = mediaItems().filter((item) => !only || item.key === only);
  const [playing, setPlaying] = useState(null);

  return (
    <div className={layout === "grid" ? "grid grid-cols-1 md:grid-cols-2 gap-10 items-start w-full" : "w-full space-y-10"}>
      {items.map((item) => (
      <section key={item.key} aria-label={`Sumo Didi ${item.label}`}>
      <p className="text-[11px] tracking-[0.2em] uppercase text-[#999] mb-6">{item.label}</p>
      <div className="aspect-video min-h-[200px] w-full bg-[#f5f4f2] relative shadow-sm overflow-hidden">
        {playing === item.embed ? (
          <iframe
            key={item.embed} src={item.embed} title={`Sumo Didi ${item.label}`}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen; web-share"
            referrerPolicy="strict-origin-when-cross-origin" allowFullScreen
            className="w-full h-full border-0 absolute inset-0"
          />
        ) : (
          <button type="button" onClick={() => setPlaying(item.embed)} aria-label={`Play Sumo Didi ${item.label.toLowerCase()}`}
            className="group block cursor-pointer w-full h-full absolute inset-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-4px] focus-visible:outline-[#1a1a1a]">
            {item.thumbnail ? (
              <img src={item.thumbnail} alt={`Sumo Didi ${item.label}`} className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.03] motion-reduce:transition-none" />
            ) : (
              <span className="absolute inset-0 flex items-end justify-center pb-8 text-[12px] text-[#777] uppercase tracking-[0.12em]">Watch {item.label}</span>
            )}
            <span className="absolute inset-0 flex items-center justify-center pointer-events-none">
              <span className={`relative flex items-center justify-center w-14 h-14 rounded-full border ${item.thumbnail ? "border-white/80 bg-black/25 text-white" : "border-[#999] text-[#1a1a1a]"}`}>
                <svg width="13" height="13" viewBox="0 0 12 12" fill="currentColor" className="ml-[2px]" aria-hidden="true"><path d="M2 1.5v9l8-4.5z" /></svg>
              </span>
            </span>
          </button>
        )}
      </div>
      {item.copy && <p className="text-[15px] text-[#4a4a4a] leading-[1.8] mt-5 whitespace-pre-line">{item.copy}</p>}
      {showLinks && <a href={item.url} target="_blank" rel="noopener" className="inline-flex items-center gap-2 mt-5 text-[12px] tracking-[0.1em] uppercase text-[#555] hover:text-[#1a1a1a]">Watch {item.label} on {item.provider} <ExternalLink size={13} /></a>}
      </section>
      ))}
    </div>
  );
}

export function SumoDidiMediaLinks() {
  return mediaItems().map((item) => (
    <a key={item.key} href={item.url} target="_blank" rel="noopener"
      className="group inline-flex items-center gap-2 text-[12px] tracking-[0.12em] uppercase text-[#1a1a1a] opacity-50 hover:opacity-100 transition-opacity duration-500">
      Watch {item.label} on {item.provider}
      <ExternalLink size={13} className="transition-transform duration-500 group-hover:translate-x-0.5" />
    </a>
  ));
}
